import { render, staticRenderFns } from "./component_video.vue?vue&type=template&id=f7cdeaee&scoped=true&"
import script from "./component_video.vue?vue&type=script&lang=js&"
export * from "./component_video.vue?vue&type=script&lang=js&"
import style0 from "./component_video.vue?vue&type=style&index=0&id=f7cdeaee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7cdeaee",
  null
  
)

export default component.exports